// extracted by mini-css-extract-plugin
module.exports =  {"table":"pvrVQZFye2qSXRNs5COh"};